import { createSlice } from '@reduxjs/toolkit';

import { loadReportDocumentsList } from './actions';
import { IReportDocumentsState } from './interfaces';

export const reportDocumentsSlice = createSlice({
  name: 'reportDocuments',
  initialState: {
    list: [],
    limit: 5,
    total: 0,
    offset: 0,
  } as IReportDocumentsState,
  reducers: {
    resetDocuments: state => {
      state.list = [];
      state.total = 0;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      loadReportDocumentsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
  },
});

export const { resetDocuments } = reportDocumentsSlice.actions;
